import { api, post } from '../../service';
import { DIALOG_ADD } from '../../libs/enum';

const defaultForm = () => ({
    siteId: 0,
    name: '',
    mobile: '',
    city: [],
    address: '',
});
const defaultState = () => ({
    dialog: {
        visible: false,
        type: DIALOG_ADD,
    },
    form: defaultForm(),
    search: {
        size: 10,
        page: 1,
        key: '',
    },
    total: 0,
    sites: [],
});

const moduleSite = {
    namespaced: true,
    state: defaultState(),
    actions: {
        clearState({ commit }) {
            commit('clearState');
        },
        async searchSites({ commit, state, rootState }) {
            const params = Object.assign(
                {},
                { ...state.search },
                {
                    agentId: rootState.userInfo.agentId,
                }
            );
            const res = await post(api.site.search, params);
            commit('changeSites', res);
        },
        async addSite({ commit, dispatch, state }) {
            const { siteId, name, mobile, city, address } = state.form;
            const params = {
                siteId,
                name,
                mobile,
                location: `${city.toString()},${address}`,
            };
            await post(api.site.add, params);
            commit('changeDialog', { visible: false });
            dispatch('searchSites');
        },
        async editSite({ commit, dispatch, state }) {
            const { siteId, name, mobile, city, address } = state.form;
            const params = {
                siteId,
                name,
                mobile,
                location: `${city.toString()},${address}`,
            };
            await post(api.site.edit, params);
            commit('changeDialog', { visible: false });
            dispatch('searchSites');
        },
        async enableSite({ dispatch }, data) {
            await post(api.site.enable, data);
            dispatch('searchSites');
        },
        changeDialog({ commit }, data) {
            commit('changeDialog', data);
        },
        changeForm({ commit }, data) {
            commit('changeForm', data);
        },
        changeSearch({ commit, dispatch }, data) {
            commit('changeSearch', data);
            dispatch('searchSites');
        },
    },
    mutations: {
        clearState(state) {
            Object.assign(state, defaultState());
        },
        changeSites(state, data) {
            state.sites = data.sites;
            state.total = data.totalCount;
        },
        changeDialog(state, data) {
            Object.assign(state.dialog, data);
            if (!data.visible) {
                state.form = defaultForm();
            }
        },
        changeForm(state, data) {
            Object.assign(state.form, data);
        },
        changeSearch(state, data) {
            Object.assign(state.search, data);
        },
    },
};

export default moduleSite;
